export default __webpack_public_path__ + "static/media/A4_COPY.edd7ada7.png";